import type { SearchPerformedOrigin } from 'src/app/_core/analytics/events/search-performed-event';
import { SearchRequestBody } from '../../service/search.model';

export class SearchRecords {
  static readonly type = '[Search/Records] - Search records';

  constructor(
    public page: number,
    public query: string,
    public additionalData?: SearchRequestBody,
    public order?: string,
    public searchOrigin: SearchPerformedOrigin = 'none'
  ) {}
}

export class AddSearchRecordToList {
  static readonly type = '[Search/Records] - Add record to list';

  constructor(
    public userId: string,
    public listId: string,
    public recordId: string
  ) {}
}

export class RemoveSearchRecordFromList {
  static readonly type = '[Search/Records] - Remove record from list';

  constructor(
    public userId: string,
    public listId: string,
    public recordId: string,
    public elementWishListId: string
  ) {}
}

export class AddToFavorites {
  static readonly type = '[Search/Records] - Add to favorites';

  constructor(public recordId: string) {}
}

export class RemoveFromFavorites {
  static readonly type = '[Search/Records] - Remove from favorites';

  constructor(public recordId: string) {}
}

export class ResetStore {
  static readonly type = '[Search/Records] - Reset store';
}
